import { Icons } from "../../assets/icons";
import { Row, Typography, Col } from "antd";
import { ListItem } from "../AwarnessSections/SectionOne.default";

export interface CompletedStageCardProps {
  readonly title: string;
  readonly subTitleText: React.ReactNode;
  readonly list: ListItem[];
}

function CompletedStageCard(props: CompletedStageCardProps) {
  return (
    <Row className="flex flex-row rounded-xl bg-[#f2f2f2] p-7 shadow-xl shadow-slate-400/50">
      {/* Left Side */}
      <Col className="flex-1">
        <Typography.Title
          level={3}
          className="text-4xl tracking-tight text-[#1a1b4b]"
        >
          {props.title}
        </Typography.Title>
        <Typography.Text className="text-xl tracking-wide text-[#1a1b4b]">
          {props.subTitleText}
        </Typography.Text>
        <ol className="w-4/5 text-justify">
          {props.list.map((listItem, index) => {
            return (
              <div key={index}>
                <li className="text-lg tracking-wide">{listItem.name}</li>
                <ul>
                  {listItem.items.map((item, index) => {
                    return (
                      <li key={index} className="text-lg tracking-wide">
                        {item}
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </ol>
      </Col>
      {/* Right Side */}
      <Col className="flex flex-col justify-center">
        <Icons.CompletedStageIcon width={350} height={350} />
      </Col>
    </Row>
  );
}

export default CompletedStageCard;
